import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { Event, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { LyDialog } from '@alyle/ui/dialog';
import { CropperDialogComponent } from '../../meu-perfil/cropper-dialog/cropper-dialog.component';
import { ImgCropperEvent } from '@alyle/ui/image-cropper';
import { ProfissionalService } from '../../services/rh/profissional.service';
import { RequestService } from '../../services/utils/request/request.service';
import { SidenavService } from '../../services/main/sidenav.service';

import { MatSidenav } from '@angular/material/sidenav';
import { ChamadoEnfermagemService } from '../../services/chat/chamado-enfermagem.service';
import { ChamadoService } from '../../services/chat/chamado.service';
import { ChamadoTiService } from '../../services/chat/chamado-ti.service';
import { ChatGeralService } from '../../services/chat/chat-geral.service';
import { AuthService } from '../../services/vos/auth.service';
import { HomeService } from '../../services/home/home.service';
import { NotificacaoServices } from '../../services/vos/notificacao.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalNotificacaoComponent } from '../../administrador/notificacao/modal-notificacao/modal-notificacao.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectsService } from '../../services/utils/selects.service';
import { ReportUtil } from '../../operacao/relatorio-prestador/meus-relatorios/util/reports.util';

@Component({
  selector: 'app-nav-mobile',
  templateUrl: './nav-mobile.component.html',
  styleUrls: ['./nav-mobile.component.css'],
})
export class NavMobileComponent implements OnInit {
  user: any;
  @ViewChild('drawer') public sidenav: MatSidenav;

  showLoading = true;
  menu_icon: any = 'menu';
  observableEnfermagem: any = null;
  observableTi: any = null;
  observableChamado: any = null;
  observableChat: any = null;
  observableResize: any = null;
  actualWidth: number;
  mobileNav: boolean;
  searchActive: boolean = false;

  marca_chamado_ti: boolean = false;
  marca_ocorrencias: boolean = false;
  marca_chamado_enfermagem: boolean = false;
  marca_chamado: boolean = false;
  marca_chat: boolean = false;
  route_actual: string = '';
  totalNotificacoes: number = 0;
  logo: any;
  @Input() title?: string = 'ML Web';
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  notificacoes: any[] = [];
  avisos: any[] = [];
  inscricao: Subscription;
  tipos: Array<any>;
  form: FormGroup;
  filteredOptions: Observable<any[]>;
  term: any;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private profissionalService: ProfissionalService,
    public authService: AuthService,
    private requestService: RequestService,
    private sidenavService: SidenavService,
    private chamadoEnfermagem: ChamadoEnfermagemService,
    private chamado: ChamadoService,
    private chamadoTi: ChamadoTiService,
    private chatService: ChatGeralService,
    private homeService: HomeService,
    private notificacaoService: NotificacaoServices,
    public dialog: MatDialog,
    private selectsService: SelectsService,
    private formBuilder: FormBuilder,
    public reportUtil: ReportUtil
  ) {
    this.tipos = this.selectsService.verifyAcessUser();
    this.usuario();
    this.router.events.subscribe((routeEvent: Event) => {
      if (routeEvent instanceof NavigationStart) {
        this.showLoading = true;
      }

      if (routeEvent instanceof NavigationEnd) {
        this.buscarNotificacoes();
        this.showLoading = false;
        this.route_actual = routeEvent.url;

        if (routeEvent.url == '/main/chat/chat-geral') {
          this.marca_chat = false;
        } else if (routeEvent.url == '/main/home') {
          this.marca_ocorrencias = false;
        } else if (routeEvent.url == '/main/chat/chamados-enfermagem') {
          this.marca_chamado_enfermagem = false;
        } else if (routeEvent.url == '/main/chat/chamados-ti') {
          this.marca_chamado_ti = false;
        } else if (routeEvent.url == '/main/chat/chamados') {
          this.marca_chamado = false;
        }
      }
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      filter: ''
    })
    this.filteredOptions = this.form.get('filter').valueChanges.pipe(
      startWith(''),
      map(value => this._filterGroup(value)),
    );

  }

  // Barra de pesquisa com autocomplete

  private _filterGroup(value: any): any[] {
    if (value) {
      return this.tipos
        .map((group) => ({
          module: group.module,
          components: this._filter(group.components, value),
        }))
        .filter((group) => group.components.length > 0);
    }

    return this.tipos;
  }

  private _filter(opt: any[], value: string): string[] {
    const filterValue = value.toLowerCase();
    return opt.filter((item) => item.label.toLowerCase().includes(filterValue));
  }

  navigateTo(value) {
    this.router.navigate([value]);
    this.closeNav();
    this.searchSetState('minhaDiv');
  }

  searchSetState(attribute) {
    var display = document.getElementById(attribute).style.display;
    if (display == 'none') {
      document.getElementById(attribute).style.display = 'block';
    } else {
      document.getElementById(attribute).style.display = 'none';
    }
    this.searchActive = !this.searchActive
  }
  //

  usuario() {
    this.user = JSON.parse(this.authService.getUserLoggedIn());
    this.user?.user.acessos.sort((a, b) => a.nome.localeCompare(b.nome));
    if (this.user?.user.pessoa.profissional)
      this.logo = this.user.user.pessoa.profissional.empresa;
    if (this.user?.user.pessoa.cliente)
      this.logo = this.user.user.pessoa.cliente.empresa;
    if (this.user?.user.pessoa.responsavel)
      this.logo = this.user.user.pessoa.responsavel.empresa;

    this.buscarNotificacoes();

    this.inscricao = this.homeService
      .getPendencias(this.user)
      .subscribe((res: any) => {
        this.marca_chamado_enfermagem =
          this.route_actual != '/main/chat/chamados-enfermagem'
            ? res.pendencia_chamado_enfermagem
            : false;
        this.marca_ocorrencias =
          this.route_actual != '/main/home'
            ? res.pendencia_chamado_home
            : false;
        this.marca_chamado_ti =
          this.route_actual != '/main/chat/chamados-ti'
            ? res.pendencia_chamado_ti
            : false;
        this.marca_chat =
          this.route_actual != '/main/chat/chat-geral'
            ? res.pendencia_chat
            : false;
        this.marca_chamado =
          this.route_actual != '/main/chat/chamados'
            ? res.pendencia_chamado
            : false;

        if (this.verificaAcesso('Área Clínica')) {
          this.observableEnfermagem =
            this.chamadoEnfermagem.dataObservable.subscribe((event: any) => {
              const data = JSON.parse(event.data);
              if (
                data.type == 'message' ||
                data.type == 'video' ||
                data.type == 'image'
              ) {
                if (data.chamado.ocorrencia != null) {
                  if (this.route_actual != '/main/home') {
                    this.marca_ocorrencias = true;
                  }
                } else {
                  if (this.route_actual != '/main/chat/chamados-enfermagem') {
                    this.marca_chamado_enfermagem = true;
                  }
                }
              }
            });
          this.chamadoEnfermagem.connect(this.user);
        }

        if (this.user?.user?.pessoa?.profissional?.empresa_id == 2) {
          this.observableTi = this.chamadoTi.dataObservable.subscribe(
            (event: any) => {
              const data = JSON.parse(event.data);
              if (this.route_actual != '/main/chat/chamados-ti') {
                if (
                  data.type == 'message' ||
                  data.type == 'video' ||
                  data.type == 'image'
                ) {
                  this.marca_chamado_ti = true;
                }
              }
            }
          );
          this.chamadoTi.connect(this.user);
        }

        this.observableChat = this.chatService.dataObservable.subscribe(
          (event: any) => {
            const data = JSON.parse(event.data);
            if (this.route_actual != '/main/chat/chat-geral') {
              if (
                data.type == 'message' ||
                data.type == 'video' ||
                data.type == 'image'
              ) {
                this.marca_chat = true;
              }
            }
          }
        );
        this.chatService.connect(this.user);

        this.observableChamado = this.chamado.dataObservable.subscribe(
          (data: any) => {
            if (this.route_actual != '/main/chat/chamados') {
              if (
                data.type == 'message' ||
                data.type == 'video' ||
                data.type == 'image'
              ) {
                this.marca_chamado = true;
              }
            }
          }
        );
        this.chamado.connect(this.user);
      });
  }
  primeiroNome(nomecompleto) {
    nomecompleto = nomecompleto.replace(/\s(de|da|dos|das)\s/g, ' ');
    var nome = nomecompleto.split(' ')[0].toLowerCase();
    return `Olá, ${nome}`;
  }
  logout() {
    this.authService.logout();
    if (this.chamadoEnfermagem.socket != null) {
      this.chamadoEnfermagem.need_reconnect = false;

      this.chamadoEnfermagem.socket.close();
    }
    if (this.chamadoTi.socket != null) {
      this.chamadoTi.need_reconnect = false;

      this.chamadoTi.socket.close();
    }
    if (this.chamado.websocket != null) {
      this.chamado.need_reconnect = false;

      this.chamado.websocket.close();
    }
    if (this.chatService.socket != null) {
      this.chatService.need_reconnect = false;

      this.chatService.socket.close();
    }

    if (this.observableChamado != null) {
      this.observableChamado.unsubscribe();
    }

    if (this.observableChat != null) {
      this.observableChat.unsubscribe();
    }

    if (this.observableEnfermagem != null) {
      this.observableEnfermagem.unsubscribe();
    }

    if (this.observableTi != null) {
      this.observableTi.unsubscribe();
    }
  }
  second() {
    if (this.menu_icon == 'menu') {
      this.menu_icon = 'keyboard_tab';
    } else if (this.menu_icon == 'keyboard_tab') {
      this.menu_icon = 'menu';
    }
  }
  alterarTitulo(titulo: string) {
    this.title = titulo;
  }

  openCropperDialog() {
    this._dialog
      .open<CropperDialogComponent>(CropperDialogComponent, {
        width: 320,
        disableClose: true,
      })
      .afterClosed.subscribe((result?: ImgCropperEvent) => {
        if (result) {
          this.salvarImagemPerfil(result.dataURL);
        }
      });
  }

  salvarImagemPerfil(data) {
    this.user.user.pessoa.perfil = data;
    this._cd.markForCheck();
    this.requestService.request(
      this.profissionalService.atualizarFotoPerfil(this.user)
    );
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }
  verificaAcesso(acesso: string) {
    let a = this.user?.user.acessos.find((x) => x.nome === acesso);
    return a ? true : false;
  }
  buscarNotificacoes() {
    if (this.user?.user && this.user?.user?.pessoa?.profissional) {
      this.inscricao = this.notificacaoService
        .notificacoesporprofissional(this.user?.user?.pessoa.profissional?.id)
        .subscribe((res) => {
          this.notificacoes = res.filter((x) => x.tipo == 'Novidades');
          this.avisos = res.filter((x) => x.tipo == 'Alerta');
          this.totalNotificacoes = res.filter((x) => !x.visto).length;
        });
    }
  }
  openDialogNotificacao(item) {
    if (!item.visto) {
      item.visto = true;
      this.inscricao = this.notificacaoService
        .atualizarServico(item.id, item)
        .subscribe(
          (res) => {},
          (error) => {
            item.visto = !item.visto;
          }
        );
    }
    const dialogRef = this.dialog.open(ModalNotificacaoComponent, {
      data: item,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  ngOnDestroy() {
    if (this.inscricao) this.inscricao.unsubscribe();
  }

  closeNav(){
    const menu = document.getElementById("navbarSupportedContent")
    menu.classList.remove("show")
  }

}
